module.exports = __webpack_public_path__ + "img/ic24Locationgray.001b99bb.svg";